export type DatabaseProvider = 'supabase' | 'cloudsql';

/** Small header badge icons bundled with the app. */
export const DATABASE_PROVIDER_CONFIG: Record<
  DatabaseProvider,
  { iconUrl: string; label: string; tooltip: string }
> = {
  supabase: {
    iconUrl: 'assets/img/database-providers/supabase.png',
    label: 'Supabase',
    tooltip: 'Supabase Powered',
  },
  cloudsql: {
    iconUrl: 'assets/img/database-providers/cloud-sql.png',
    label: 'Google Cloud SQL',
    tooltip: 'Google Cloud powered',
  },
};
